module.exports = __webpack_public_path__ + "images/phone-f6c4136e.png";


//////////////////
// WEBPACK FOOTER
// ./images/phone.png
// module id = 991
// module chunks = 0